import React from "react";

import { GET_POPUPS } from "../const/router";
import useGetPopupsState from "../hooks/useGetPopupsState";
import ProfilePopup from '../pages/Profile/ProfilePopup';
import ChatPopup from '../pages/Chat/ChatPopup';
import AdvancedSearchPopup from './../pages/AdvancedSearch/AdvancedSearchPopup';
import BounakirMessagePopup from './../pages/DoubleMatch/BounakirMessagePopup';
import FindYourAccountPopup from './../pages/AccountPages/FindYourAccountPopup';
import PremiumMessagePopup from "./premium/PremiumMessagePopup";
import PremiumOptionsPopup from "./premium/PremiumOptionsPopup";
import PremiumPlanDetailsPopup from "./premium/PremiumPlanDetailsPopup";

const mappedPopups = {
    [GET_POPUPS.popup.profile]: ProfilePopup,
    [GET_POPUPS.popup.chat]: ChatPopup,
    [GET_POPUPS.popup.advancedSearch]: AdvancedSearchPopup,
    [GET_POPUPS.popup.bounakirMessage]: BounakirMessagePopup,
    [GET_POPUPS.popup.findYourAccount]: FindYourAccountPopup,
    [GET_POPUPS.popup.premiumMessage]: PremiumMessagePopup,
    [GET_POPUPS.popup.premiumOptions]: PremiumOptionsPopup,
    [GET_POPUPS.popup.premiumPlanDetails]: PremiumPlanDetailsPopup,

};

const GetParameterPopups = () => {
    const { mountedPopups, popups } = useGetPopupsState();

    return mountedPopups.map((mountedPopup: any) => {
        const Component = mappedPopups[mountedPopup];

        if (!Component) {
            return null;
        }

        return (
            <Component key={mountedPopup} isOpened={popups.includes(mountedPopup)} />
        );
    });
};

export default GetParameterPopups;
